var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.031,
    height: 16.575,
    viewBox: "0 0 19.031 16.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "weight-kilogram",
    d: "M12.515,4.5a3.746,3.746,0,0,1,3.806,3.683,3.494,3.494,0,0,1-.514,1.842h2.417a1.9,1.9,0,0,1,1.855,1.436c1.913,7.376,1.951,7.569,1.951,7.772a1.873,1.873,0,0,1-1.9,1.842H4.9A1.873,1.873,0,0,1,3,19.233c0-.2.038-.4,1.951-7.772a1.9,1.9,0,0,1,1.855-1.436H9.223a3.494,3.494,0,0,1-.514-1.842A3.746,3.746,0,0,1,12.515,4.5m0,1.842a1.843,1.843,0,1,0,1.9,1.842,1.873,1.873,0,0,0-1.9-1.842M6.806,11.867v7.367h1.9v-2.3l.952.921v1.381h1.9V17.391l-1.9-1.842,1.9-1.842V11.867h-1.9v1.381l-.952.921v-2.3h-1.9m8.564,0a1.867,1.867,0,0,0-1.9,1.842v3.683a1.867,1.867,0,0,0,1.9,1.842h2.855v-4.6h-1.9v2.762H15.37V13.708h2.855V11.867Z",
    transform: "translate(-3 -4.5)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKg);
export default __webpack_public_path__ + "static/media/kg.f29b6df9459f6cd37a10e4252e9d28ea.svg";
export { ForwardRef as ReactComponent };